
import RegisterPage from "../Component/Authentication/Register";

const routes = [
  { path: `${import.meta.env.BASE_URL}/register`, Component: <RegisterPage />},
]

export default routes;